import type { Opportunity, PageEnvelope } from "@skv/core";
import { CustomError, SharedErrors } from "@skv/core";
import type { AppThunk } from "../";

export const fetchOpportunity = (
  oppId
): AppThunk<Promise<Opportunity | CustomError>> => async (
  dispatch,
  getState
): Promise<Opportunity | CustomError> => {
  if (!oppId) {
    throw Error("No opportunity id passed as argument.");
  }

  const currentState = getState();
  const cachedResult = currentState.opportunity.data[oppId];

  if (cachedResult) {
    if (cachedResult instanceof CustomError) {
      dispatch({
        type: "OPPORTUNITY:FETCH:ERROR",
        payload: {
          id: oppId,
          error: cachedResult,
        },
      });
      return;
    }

    dispatch({
      type: "OPPORTUNITY:FETCH:END:FROMCACHE",
      payload: {
        data: cachedResult,
      },
    });

    return cachedResult;
  }

  dispatch({
    type: "OPPORTUNITY:FETCH:START",
  });

  return fetch(`/api/opportunity/${oppId}`)
    .then<PageEnvelope<{ opportunity: Opportunity }>>((res) => {
      if (res.ok) {
        return res.json();
      }

      throw new CustomError(
        "Response from server was not 200",
        SharedErrors.Opportunity
      );
    })
    .then(({ data, errorCode, errorMessage, success }) => {
      if (success) {
        dispatch({
          type: "OPPORTUNITY:FETCH:END",
          payload: {
            data: data.opportunity,
          },
        });

        return data.opportunity;
      }

      dispatch({
        type: "OPPORTUNITY:FETCH:ERROR",
        payload: {
          id: oppId,
          error: new CustomError(errorMessage, errorCode),
        },
      });
    })
    .catch((err: CustomError) => {
      console.log(err);

      dispatch({
        type: "OPPORTUNITY:FETCH:ERROR:UNKNOWN",
        payload: {
          error: err,
        },
      });

      return err;
    });
};

export const resetErrors = () => ({
  type: "OPPORTUNITY:ERROR:RESET",
});
